var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.4 397.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 198.7,
    y1: 0,
    x2: 198.7,
    y2: 397.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3de2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5881fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c513ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.7,0h0C89,0,0,89,0,198.7h0c0,109.7,89,198.7,198.7,198.7h0c109.7,0,198.7-89,198.7-198.7h0C397.4,89,308.4,0,198.7,0ZM257.5,183.3l-3.3,26.6c-.6,4.4-4.3,7.8-8.8,7.8h-43v111.1c-4.5.4-9.1.6-13.8.6-10.4,0-20.6-1-30.4-3v-108.8h-33.1c-3,0-5.5-2.5-5.5-5.5v-33.3c0-3,2.5-5.5,5.5-5.5h33.1v-49.9c0-30.6,24.7-55.4,55.2-55.4h38.6c3,0,5.5,2.5,5.5,5.5v33.3c0,3-2.5,5.5-5.5,5.5h-27.6c-12.2,0-22.1,9.9-22.1,22.2v38.8h46.4c5.4,0,9.5,4.7,8.8,10Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCircle);
export default __webpack_public_path__ + "static/media/facebook-circle.64af77b8e289dc130135275bf6ccd0cd.svg";
export { ForwardRef as ReactComponent };